var Shopify = Shopify || {};
var shop_currency = $("script#currency-formate").data("storecurrency");
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = shop_currency;
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};
$(document).ready(function() {
  customQuickView();
  $(document).on("click", ".custom-quick--view", function (event) {
    if ("custom-quick--view" == event.target.className) {
      $(".custom-quick--view").fadeOut("fast");
      $(".slider-images").removeClass("slick-initialized");
      $(".slider-images").removeClass("slick-slider");
    }
  });
  $(".quickview-append-data .quantity input[type='text']").on('blur', function() {
    if (this.value == 0) {
      this.value = 1;
    }
  });
  $(document).on("click", ".close-btn", function () {
    $(".custom-quick--view").fadeOut(200);
    $(".slider-images").html("");
    $(".slider-images").removeClass("slick-initialized");
    $(".slider-images").removeClass("slick-slider");
    $(".lightbox.custom-quick--view").removeClass("is-visible");
  });
  $(document).on('click', function(e) {
    var container = $(".custom-quick--view.is-visible");
    if (!$(e.target).closest(container).length || !container.is(e.target) == true) {
      container.show();
    }else{
      container.hide();
      $(".lightbox.custom-quick--view").removeClass("is-visible");
    }
  });
  $('.qty-input i').click(function() {
    val = parseInt($(this).parent().find('input').val());
    if ($(this).hasClass('less')) {
      val = val - 1;
    } else if ($(this).hasClass('more')) {
      val = val + 1;
    }
    if (val < 1) {
      val = 1;
    }
    $(this).parent().find('input').val(val);
  });
 
});
$(document).on("click", ".main_options_parent .color-img", function () {
    $(this).parents('.variant-option-global').find('input[type="radio"]').removeAttr('checked', false);
    $(this).attr("checked", "checked");
});

function customQuickView(){
  $(document).on("click", ".quick-view-btn", function () {
    $('.qv-product-images .slider-images').removeClass("slick-initialized");
    $('.qv-product-images .slider-images').removeClass("slick-slider");
    $(".lightbox.custom-quick--view").addClass("is-visible");
    $('.qv-quantity').val(1);
    $(".variant-row-global").html("");
    $(".variant-row-inner, .product-select, .variant_atc_btn_main").html("");
    $(".variant-option-global").html("");
    $(".qv-product-original-price").html("");
    $(".qv-prod-desc").html("");
    
    // setTimeout(function() {
      $(".slider-images").empty();
    // }, 200);
    $(".custom-quick--view").fadeIn(200);
    var productHandle = $(this).data("handle");
    
    $.ajax({
      url: "/products/" + productHandle + ".js",
      dataType: "json",
      success: function (product) {
        $(".qv-product-title").text(product.title);
        $(".qv-product-price").text(Shopify.formatMoney(product.price));
        if(product.compare_at_price > product.price){
          $(".qv-product-original-price").text(Shopify.formatMoney(product.compare_at_price));
        }
        $(".view-product").attr("href", "/products/" + productHandle);
        
        // $(".slider-images").empty();
        
        $(product.images).each(function (index, image) {
          $(".slider-images").append(
            '<div class="quickview-prod-img"><img src="' + image + '" width="100%" alt="' + product.title + '"></div>'
          );
        });
       
        $(product.options).each(function (index, option) {
          var option_name = option.name;
          var variant_html = `<div class="option-name">${option_name}</div><div class="variant-option-global">`;

          $(option.values).each(function (i, value) {
            var variant_img;
            var variant_price;
            var variant_compare_price;
            $(".product-select").html("");

            var variant_img = "";
            var variant_position = 0;
            $(product.variants).each(function (index, variant) {
              if (variant.title.includes(value) && variant.featured_image) {
                variant_img = variant;
              }
              if(product.variants[0].title == 'Default Title' || variant.featured_image == null){
                $('.product-select').append('<option class="product-select-option" var_price="'+ variant.price +'" data-quickprice="'+ variant.price +'" data-quickcprice="'+ variant.compare_at_price +'" data_title="' + variant.title + '" value="' + variant.id + '">' + variant.title + '</option>');
              }else{
                $('.product-select').append('<option class="product-select-option" data-position="'+ variant.featured_image.position +'" var_price="'+ variant.price +'" data-quickprice="'+ variant.price +'" data-quickcprice="'+ variant.compare_at_price +'" data_title="' + variant.title + '" value="' + variant.id + '">' + variant.title + '</option>');
              }
              if(product.variants[0].title == "Default Title"){
                $(".main_options_parent .variant-row-global").hide();
              } else{
                $(".main_options_parent .variant-row-global").show();
              }
            });
            if (variant_img && variant_img.featured_image) {
              variant_img = variant_img.featured_image.src;
            }
 

            variant_html += `
                <div class="option-input">`;
                  if(i == 0){
                     variant_html += `<input checked="checked" type="radio" class="color-img" id="${i}-label_${option_name}" name="${option_name}-${product.id}" value="${value}" tabindex="0">`;
                  }else{
                     variant_html += `<input type="radio" class="color-img" id="${i}-label_${option_name}" name="${option_name}-${product.id}" value="${value}" tabindex="0">`;
                  }
                  variant_html += `
                  <label for="${i}-label_${option_name}">${value}</label>
                  `;
                  if(option_name == "Color"){
                    if(variant_img != ""){
                    variant_html += `<img src="${variant_img}" width="50" height="50" alt="${value}" title="${value}">`;
                    }
                  }
                  variant_html += 
                `</div>`;
          });
          variant_html += `</div>`;
        
          $(".variant-row-global").append(variant_html);
         
        });
        variant_atc_btn = `<button type="button" class="add-to-cart-btn-global">Add to cart</button>`;
        $(".variant_atc_btn_main").html(variant_atc_btn);
        if(product.available == false){
          $("button.add-to-cart-btn-global").attr("disabled", "disabled");
        }
        $(".qv-prod-desc").html(product.description.substring(0,260) + '...');
      },
    });
  
      setTimeout(function(){
        var slick_length = $(".quickview-prod-img").length;
         if(slick_length > 1){
           $('.qv-product-images .slider-images').slick({
              dots: false,
              infinite: false,
              speed: 300,
              slidesToShow: 1,
              slidesToScroll: 1,
              responsive: [
                {
                  breakpoint: 1200,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                },
                {
                  breakpoint: 991,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                },
                {
                  breakpoint: 575,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                }
              ]
            });
         }
    },1000);

    $(document).on("change", ".variant-row-global .option-input input[type='radio']", function () {
        var variant_title = '';
      var product_select_option = '';
      var data_position = "";
        $(this).parents('.main_options_parent').find('.variant-row-global .variant-option-global').each(function( index ) {
          variant_title +=  " / "+$(this).find('input[type="radio"]:checked').val();
        });
        variant_title = variant_title.slice(3);

        $('.qv-product-options .product-select-option').each(function( index ) {
          var data_title =  $(this).attr('data_title'); 
          if(variant_title == data_title){ 
            data_position = $(this).attr('data-position');
          }
          
        });
      
        var var__price = $(this).parents('.main_options_parent').find('.product-select option[data_title="'+variant_title+'"]').attr('data-quickprice');
        var var_compare_price = $(this).parents('.main_options_parent').find('.product-select option[data_title="'+variant_title+'"]').attr('data-quickcprice');
        $(this).parents(".qv-prod-info").find(".qv-product-price").text(Shopify.formatMoney(var__price));
        if(var_compare_price != 'null'){
          $(this).parents(".qv-prod-info").find(".qv-product-original-price").text(Shopify.formatMoney(var_compare_price));
        } else{
          $(".qv-product-original-price").html("");
        }

        if(data_position>0){
          $('.slider-images').slick('slickGoTo', data_position-1);
        }
    });  
  });
$(document).on('click','.add-to-cart-btn-global', function() {
  var variant_title = '';
  $(this).parents('.main_options_parent').find('.variant-row-global .variant-option-global').each(function( index ) {
    variant_title +=  " / "+$(this).find('input[type="radio"]:checked').val();
  });
  variant_title = variant_title.slice(3);
  var variant_id = $(this).parents('.main_options_parent').find('.product-select option[data_title="'+variant_title+'"]').attr('value');
  var quantity = $('.qv-quantity').val();
  var data = {
    "quantity": quantity,
    "id": variant_id
  }
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function(data) {
      window.location = "/cart";
    },
    error: function (data) {
      if (data.status == 422) {
        alert("Selected product is already soldout!");
      }
    }
  });
});  
}